import { SimpleMutationOptions, useBaseMutation } from "../baseMutation";
import { UpdateFolderSharingSettingRequest, UpdateFolderSharingSettingResponse } from "@maven-rest/docs/FolderSharingSetting.dto";
import { FolderSharingSettingUrl } from "@maven-rest/docs/FolderSharingSetting.url";

export function useUpdateFolderSharingSettingMutation(
  options?: SimpleMutationOptions<UpdateFolderSharingSettingResponse, UpdateFolderSharingSettingRequest>
) {
  return useBaseMutation({
    fnOption: {
      url: FolderSharingSettingUrl.updateFolderSharingSetting,
    },
    ...options,
  });
}
